import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

/**
 * Gate every authenticated route. If we don't have a hydrated user yet,
 * render nothing (the layout shows nothing for a few ms while `/auth/me`
 * resolves). After bootstrap, redirect unauthenticated users to /login.
 */
export default function ProtectedRoute({ children }) {
  const { authReady, activeUser } = useApp();
  const location = useLocation();

  if (!authReady) {
    return (
      <div
        className="flex min-h-screen items-center justify-center text-sm text-slate-400"
        data-testid="auth-bootstrap"
      >
        Loading...
      </div>
    );
  }
  if (!activeUser) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
